import ManualBillingDocumentAmountHt from '@/generated/controls/manualBillingDocument/ManualBillingDocumentAmountHt.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentAmountHt
})
